/* eslint-disable */
import React, { createContext, useState, ReactNode } from 'react';
import {
  IdentityInterface,
  OptionInterface,
} from '../../interface/CustomerInformationInterface';

interface IdentityContextInterface {
  identityInformation: IdentityInterface;
  setIdentityInformation: React.Dispatch<
    React.SetStateAction<IdentityInterface>
  >;
  genderDropOptions: OptionInterface[];
  setGenderDropOptions: React.Dispatch<React.SetStateAction<OptionInterface[]>>;
  maritalStatusDropOptions: OptionInterface[];
  setMaritalStatusDropOptions: React.Dispatch<
    React.SetStateAction<OptionInterface[]>
  >;
  racPromotionDropOptions: OptionInterface[];
  setRacPromotionDropOptions: React.Dispatch<
    React.SetStateAction<OptionInterface[]>
  >;
  stgCustomerProfileId: string;
  setStgCustomerProfileId: React.Dispatch<React.SetStateAction<string>>;
  stgCustomerIdentityId: string;
  SetStgCustomerIdentityId: React.Dispatch<React.SetStateAction<string>>;
  detailSave: boolean;
  setDetailSave: React.Dispatch<React.SetStateAction<boolean>>;
  otpSave: boolean;
  setOtpSave: React.Dispatch<React.SetStateAction<boolean>>;
  identityFrontDocument: any;
  setIdentityFrontDocument: React.Dispatch<React.SetStateAction<any>>;
  identityBackDocument: any;
  setIdentityBackDocument: React.Dispatch<React.SetStateAction<any>>;
  isIdentityFrontDocDeleted: boolean;
  setIsIdentityFrontDocDeleted: React.Dispatch<React.SetStateAction<boolean>>;
  isIdentityBackDocDeleted: boolean;
  setIsIdentityBackDocDeleted: React.Dispatch<React.SetStateAction<boolean>>;
  frontFileType: string;
  setFrontFileType: React.Dispatch<React.SetStateAction<string>>;
  backFileType: string;
  setBackFileType: React.Dispatch<React.SetStateAction<string>>;
  frontFileSize: string;
  setFrontFileSize: React.Dispatch<React.SetStateAction<string>>;
  backFileSize: string;
  setBackFileSize: React.Dispatch<React.SetStateAction<string>>;
  linkExpirationPopup: boolean,
  setLinkExpirationPopup: React.Dispatch<React.SetStateAction<boolean>>;
  IDValidationEnable: boolean;
  setIDValidationEnable: React.Dispatch<React.SetStateAction<boolean>>;
  getCustomerRes: any,
  setGetCustomerRes: any,
  getStgCustomerRes: any,
  setGetStgCustomerRes: any
  featureFlagDetails: any;
  setFeatureFlagDetails: React.Dispatch<React.SetStateAction<any>>;
  countryCode: any;
  setCountryCode: React.Dispatch<React.SetStateAction<string>>;
  storeDetails: any;
  setStoreDetails: React.Dispatch<React.SetStateAction<any>>;
  liveLinessCheckEnable: boolean;
  setLiveLinessCheckEnable: React.Dispatch<React.SetStateAction<boolean>>;
  liveLinessCompleted: boolean;
  setLiveLinessCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  showSelfieDocument: boolean,
  setShowSelfieDocument: React.Dispatch<React.SetStateAction<boolean>>;
  selfieDoc: any,
  setSelfieDoc: React.Dispatch<React.SetStateAction<any>>;
  fileSize: string;
  setFileSize: React.Dispatch<React.SetStateAction<string>>;
  fileType: string;
  setFileType: React.Dispatch<React.SetStateAction<string>>;
  customerId: string;
  setCustomerId: React.Dispatch<React.SetStateAction<string>>;
  secretValues: any;
  setSecretValues: React.Dispatch<React.SetStateAction<any>>;
  idValidationCompleted: boolean;
  setIdValidationCompleted: React.Dispatch<React.SetStateAction<boolean>>;
}

const IdentityContext = createContext<IdentityContextInterface | undefined>(
  undefined
);

const IdentityContextProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [identityInformation, setIdentityInformation] =
    useState<IdentityInterface>({
      firstName: '',
      secondName: '',
      paternalLastName: '',
      maternalLastName: '',
      curp: '',
      ineVoterid: '',
      gender: '',
      dateOfBirth: '',
      maritalStatus: '',
      phoneNumber: '',
      emailId: '',
      racPromotions: '',
      rfc: '',
      consentDate: '',
    });

  const [genderDropOptions, setGenderDropOptions] = useState<OptionInterface[]>(
    []
  );
  const [maritalStatusDropOptions, setMaritalStatusDropOptions] = useState<
    OptionInterface[]
  >([]);
  const [racPromotionDropOptions, setRacPromotionDropOptions] = useState<
    OptionInterface[]
  >([]);
  const [stgCustomerProfileId, setStgCustomerProfileId] = useState<string>('0');
  const [customerId, setCustomerId] = useState<string>('');
  const [stgCustomerIdentityId, SetStgCustomerIdentityId] =
    useState<string>('0');
  const [detailSave, setDetailSave] = useState<boolean>(false);
  const [otpSave, setOtpSave] = useState<boolean>(false);
  const [identityFrontDocument, setIdentityFrontDocument] = useState<any>('');
  const [identityBackDocument, setIdentityBackDocument] = useState<any>('');
  const [isIdentityFrontDocDeleted, setIsIdentityFrontDocDeleted] =
    useState<boolean>(false);
  const [isIdentityBackDocDeleted, setIsIdentityBackDocDeleted] =
    useState<boolean>(false);
  const [frontFileType, setFrontFileType] = useState<string>('');
  const [backFileType, setBackFileType] = useState<string>('');
  const [frontFileSize, setFrontFileSize] = useState<string>('');
  const [backFileSize, setBackFileSize] = useState<string>('');
  const [linkExpirationPopup, setLinkExpirationPopup] = useState<boolean>(false);
  let [IDValidationEnable, setIDValidationEnable] = useState<boolean>(false);
  const [getCustomerRes, setGetCustomerRes] = useState<any>('')
  const [getStgCustomerRes, setGetStgCustomerRes] = useState<any>('')
  const [featureFlagDetails, setFeatureFlagDetails] = useState<any>({});
  const [countryCode, setCountryCode] = useState<any>([]);
  const [storeDetails, setStoreDetails] = useState<any>({});
  const [liveLinessCheckEnable, setLiveLinessCheckEnable] = useState<boolean>(false)
  const [liveLinessCompleted, setLiveLinessCompleted] = useState<boolean>(false)
  const [showSelfieDocument, setShowSelfieDocument] =
    useState<boolean>(false);
  const [selfieDoc, setSelfieDoc] = useState<string>('');
  const [fileSize, setFileSize] = useState<string>('');
  const [fileType, setFileType] = useState<string>('');
  const [secretValues, setSecretValues] = useState<any>('');
  const [idValidationCompleted, setIdValidationCompleted] = useState<boolean>(false);

  return (
    <IdentityContext.Provider
      value={{
        identityInformation,
        setIdentityInformation,
        genderDropOptions,
        setGenderDropOptions,
        maritalStatusDropOptions,
        setMaritalStatusDropOptions,
        racPromotionDropOptions,
        setRacPromotionDropOptions,
        stgCustomerProfileId,
        setStgCustomerProfileId,
        stgCustomerIdentityId,
        SetStgCustomerIdentityId,
        detailSave,
        setDetailSave,
        otpSave,
        setOtpSave,
        identityFrontDocument,
        setIdentityFrontDocument,
        identityBackDocument,
        setIdentityBackDocument,
        isIdentityFrontDocDeleted,
        setIsIdentityFrontDocDeleted,
        isIdentityBackDocDeleted,
        setIsIdentityBackDocDeleted,
        frontFileType,
        setFrontFileType,
        backFileType,
        setBackFileType,
        frontFileSize,
        setFrontFileSize,
        backFileSize,
        setBackFileSize,
        linkExpirationPopup,
        setLinkExpirationPopup,
        IDValidationEnable,
        setIDValidationEnable,
        getCustomerRes, setGetCustomerRes,
        getStgCustomerRes, setGetStgCustomerRes,
        featureFlagDetails,
        setFeatureFlagDetails,
        countryCode,
        setCountryCode,
        storeDetails,
        setStoreDetails,
        liveLinessCheckEnable, setLiveLinessCheckEnable,
        liveLinessCompleted, setLiveLinessCompleted,
        showSelfieDocument, setShowSelfieDocument,
        selfieDoc, setSelfieDoc,
        fileSize,
        setFileSize,
        fileType,
        setFileType,
        customerId, setCustomerId,
        secretValues, setSecretValues,
        idValidationCompleted, setIdValidationCompleted,
      }}
    >
      {props.children}
    </IdentityContext.Provider>
  );
};

export { IdentityContext, IdentityContextProvider };
